import { useState, useEffect, useContext } from "react";
import { motion } from "framer-motion";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "../../includes/footer-tab"; // Adjust path
import Preloader from "../Preloader"; // Adjust path
import BackButton from "../../includes/Back_btn"; // Adjust path
import { AuthContext } from "../../context/AuthContext"; // Adjust path
import { useNavigate, Link } from "react-router-dom";
import styles from '../../assets/css/Recharge.module.css'; // Import NEW CSS Module
import { AiOutlineHistory } from "react-icons/ai"; // History Icon

function Recharge() {
  const navigate = useNavigate();
  const {
      isAuthenticated,
      profile,
      AddMoney,
      app_logo = "/favicon.png" // Get logo from context or use default
    } = useContext(AuthContext);
  const [preloader, setPreloader] = useState(true);
  const [Balance, setBalance] = useState(0);
  const [Amount, setAmount] = useState("");
  const [Minimum, setMinimum] = useState(100); // Default minimum

  // Redirect if not authenticated
  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate]);

  // Toast message function
  const message = (status, text) => {
    const options = {
        position: "top-right", autoClose: 3000, hideProgressBar: false,
        closeOnClick: true, pauseOnHover: true, draggable: true,
        progress: undefined, theme: "dark", // Use dark theme
    };
    if (status === 1) toast.success(text, options);
    else if (status === 0) toast.error(text, options);
    else if (status === 2) toast.warning(text, options);
  };

  // Fetch profile data (balance, minimum recharge)
  useEffect(() => {
    let isMounted = true;
    setPreloader(true);
    if (profile) {
        profile((response) => { // Changed 'data' to 'response' for clarity
            if (!isMounted) return;
            setPreloader(false);
            if (response.status === 0) { // Check status from API response
                message(0, response.msg || "Failed to load profile");
            } else if (response.data && response.data.length > 0) {
                setBalance(response.data[0].wallet || 0);
                // Assuming minimum recharge comes from user_Data array, index 5
                // Use optional chaining and provide default
                setMinimum(response.user_Data?.[5]?.minimum_recharge || 100);
            } else {
                message(0, "Profile data not found");
            }
        });
    } else {
        setPreloader(false); // Hide preloader if profile function isn't available
    }
    return () => { isMounted = false; }; // Cleanup
  }, [profile]);

  // Handle Recharge Action
  const handleRecharge = () => {
    const numericAmount = parseFloat(Amount); // Ensure Amount is treated as number

    if (isNaN(numericAmount) || Amount === "" || numericAmount <= 0) {
        message(0, "Please enter a valid amount");
        return;
    }
    if (numericAmount < Minimum) {
      message(0, `Minimum recharge amount is ₹${Minimum}`);
      return;
    }
    setPreloader(true); // Show preloader during API call
    if (AddMoney) {
        AddMoney(numericAmount, (res) => { // Pass numericAmount
            setPreloader(false); // Hide preloader after API call
            if (res.status === 0) {
                message(0, res.msg || "Recharge failed");
            } else if (res.url) {
                // Redirect to payment gateway
                window.location.href = res.url;
            } else {
                 message(0, "Invalid response from server.");
            }
        });
    } else {
        setPreloader(false);
        message(0,"Recharge function not available.");
    }
  };

  // Framer Motion variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
  };
  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { type: 'spring', stiffness: 100 } },
  };

  // Filter recommended amounts to be >= Minimum
  const recommendedAmounts = [100, 200, 500, 1000, 2000, 5000].filter(val => val >= Minimum);
  // Ensure Minimum is included if not in the list
  if (!recommendedAmounts.includes(Minimum)) {
      recommendedAmounts.unshift(Minimum); // Add Minimum to the beginning
      recommendedAmounts.sort((a, b) => a - b); // Keep sorted
  }


  return (
    <>
      <Preloader status={preloader} />
      <ToastContainer position="top-right" autoClose={3000} theme="dark" />

      {/* Use the Aghori theme container */}
      <div className={styles.aghoriRechargeContainer}>
        {!preloader && (
            <motion.div
                variants={containerVariants}
                initial="hidden"
                animate="visible"
                exit={{ opacity: 0 }}
            >
                {/* --- Header --- */}
                <motion.div className={styles.aghoriHeader} variants={itemVariants}>
                    {/* Assuming BackButton is styled or accepts className */}
                    <BackButton className={styles.backButton} />
                    <p className={styles.headerTitle}>Recharge</p>
                    
                </motion.div>

                {/* --- Recharge Box --- */}
                <motion.div className={styles.aghoriRechargeBox} variants={itemVariants}>
                    <img src={app_logo} className={styles.rechargeLogo} alt="Logo"/>

                    <div className={styles.balanceDisplay}>
                        Balance: ₹{Balance}
                    </div>

                    <div className={styles.inputGroup}>
                        <label htmlFor="amountInput" className={styles.inputLabel}>Enter Amount (Min: ₹{Minimum})</label>
                        <div className={styles.amountInputContainer}>
                            <span className={styles.currencySymbol}>₹</span>
                            <input
                                id="amountInput"
                                type="number" // Use number type
                                inputMode="decimal" // Hint for numeric keyboard
                                className={styles.amountInput}
                                onInput={(event) => {
                                    // Allow only numbers
                                    const value = event.target.value.replace(/[^0-9]/g, '');
                                    setAmount(value !== "" ? value : "");
                                }}
                                placeholder="0" // Simple placeholder
                                value={Amount}
                            />
                        </div>
                    </div>


                    <div className={styles.recommendedAmount}>
                        {recommendedAmounts.map((value) => (
                            <button
                                key={value}
                                className={styles.amountButton}
                                onClick={() => setAmount(String(value))} // Set amount as string
                            >
                                ₹{value}
                            </button>
                        ))}
                    </div>

                    <div className={styles.payButtonContainer}>
                        <button className={styles.payButton} onClick={handleRecharge} disabled={preloader}>
                            {preloader ? 'Processing...' : 'PAY BY UPI'}
                        </button>
                    </div>
                </motion.div>
            </motion.div>
        )}
      </div>

      {/* --- Footer --- */}
      <Footer /> {/* Ensure Footer uses the correct CSS */}
    </>
  );
}

export default Recharge;
